import CommonDatePicker from "@/common/elements/DatePicker";
import Checkbox from "@/common/elements/InputElements/CheckBox";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import TimePicker from "@/common/elements/TimePicker";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { Form } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const VictimNotificationAttemptForm = ({selectedVictim, updateFormValue}) =>{
    const { bookingsFieldsEnabled } = useSelector(
        (state) => state?.bookings
    );

    const [victimLogForm] = Form.useForm();
    useEffect(() => {
        victimLogForm.setFieldsValue({
            dateTimeNotified: selectedVictim?.dateNotified ? dayjs(`${selectedVictim?.dateNotified} ${selectedVictim?.timeNotified}`) : dayjs(new Date()),
            comments: selectedVictim?.comments ? selectedVictim?.comments : null,
            notifyingOfficerStaffID: selectedVictim?.notifyingOfficerStaffID ? selectedVictim?.notifyingOfficerStaffID : null,
            method: selectedVictim?.method ? Number(selectedVictim?.method) : null,
            successful: selectedVictim?.successful === 'True' || selectedVictim?.successful === true,
        })
    }, [selectedVictim])
    return(
        <>
        <Form form={victimLogForm} onValuesChange={updateFormValue}>
        <StyledSectionHeading>
            <span>Notification Information</span>
        </StyledSectionHeading>
        <StyledGridRow gutter={16} justify="end">
            <StyledGridCol marginBottom="10px">
                <FormItem label="Successful?" 
                labelPostion="label-right"
                name="successful"
                layout="horizontal"
                className="form-item-checkbox-left"
                valuePropName="checked">
                    <Checkbox checked={victimLogForm?.getFieldValue('successful')} disabled={!bookingsFieldsEnabled}/>
                </FormItem>
            </StyledGridCol>
        </StyledGridRow>
        <StyledGridRow gutter={16}>
            <StyledGridCol lg={6}>
               <FormItem label="Method" name="method">
                    <Select 
                        options={getOptionsFromRefList("VictimNotification_Method", false, false, true)}
                        placeholder="Method"
                        showSearch={false}
                        // onChange={(e) => {
                        //     setTimeout(() => document.activeElement.blur(), 0)
                        // }}
                        variant="outlined"
                        disabled={!bookingsFieldsEnabled}
                    />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
               <FormItem label="Notifying Officer" name="notifyingOfficerStaffID">
                    <Select options={getOptionsFromRefList("", true)}
                        placeholder="Notifying Officer"
                        showSearch={false}
                        onChange={(e) => {
                            setTimeout(() => document.activeElement.blur(), 0)
                        }}
                        variant="outlined"
                        disabled={!bookingsFieldsEnabled}
                    />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={6}>
               <FormItem label="Date Notified" name="dateTimeNotified">
                    <CommonDatePicker showTime={true} format="MM/DD/YYYY HH:mm" disabled={!bookingsFieldsEnabled} />
                </FormItem>
            </StyledGridCol>

            <StyledGridCol lg={24} span={24}>
               <FormItem label="Comments" name="comments">
                    <TextField inputType="textarea" rows="3" disabled={!bookingsFieldsEnabled} />
                </FormItem>
            </StyledGridCol>

        </StyledGridRow>
        </Form>
        </>
    )
}
export default VictimNotificationAttemptForm;
